export default __webpack_public_path__ + "media/images/fencing-splat-6e392d018eb1591c1c8bdd023045f339.svg";